import {FC, useEffect, useState} from 'react';
import {IonCheckbox, IonItem} from '@ionic/react';

type ChooseColorsFiltersCheckboxProps = {
  label: string;
  setChosenFilters: Function;
  chosenFilters?: any;
  type?: string;
  id?: number;
}

const ChooseColorsFiltersCheckbox: FC<ChooseColorsFiltersCheckboxProps> = ({
  label,
  setChosenFilters,
  chosenFilters,
  type,
  id,
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (chosenFilters.length == 0 && checked) {
      setChecked(false);
    }
  }, [chosenFilters]);

  const handleChange = (e: any, id: any) => {
    if (!e.detail.checked && chosenFilters.length == 0) {
      return;
    }
    setChecked(e.detail.checked);
    const tmpChosenFilters = [...chosenFilters];
    if (tmpChosenFilters.filter((el: any) => el.id === id && el.type === type).length > 0) {
      for (let i = 0; i < tmpChosenFilters.length; i++) {
        if (tmpChosenFilters[i].id == id && tmpChosenFilters[i].type === type) {
          tmpChosenFilters.splice(i, 1);
        }
      }
    } else {
      tmpChosenFilters.push({
        id: id,
        type: type,
        label: label,
      });
    }
    setChosenFilters(tmpChosenFilters);
  };

  return (
    <IonItem lines='none' className='w-full border-b border-gray-300 last:border-b-0 min-h-[45px] ion-no-padding'>
      <label className='text-gray-900 text-sm pl-2'>{label}</label>
      <IonCheckbox
        slot='end'
        className='color-checkbox-square'
        checked={checked}
        onIonChange={(e) => handleChange(e, id)} />
    </IonItem>
  );
};

export default ChooseColorsFiltersCheckbox;
